"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = void 0;
const wait = (ms) => new Promise((res) => setTimeout(res, ms));
exports.wait = wait;
